/**
 * FEEDBACK (C1) — o cartão "Meu desenvolvimento" em Meu perfil: o plano de ação e os compromissos da última pauta
 * CONCLUÍDA de cada rodada, e o PDF. Mesmo desenho do "Meus testes": aparece só para quem tem login vinculado a uma
 * ficha de funcionário, com as flags ligadas — quem decide é o servidor (404 = o cartão não existe). Reaberta a pauta,
 * a pessoa continua vendo a última versão concluída (o servidor só manda o publicado).
 */
import { Button, Card, useToast } from '@/components/ui';
import { PlanoPublicado } from './PlanoPublicado';
import { errMsg } from '@/lib/api-error';
import { useMyFeatureFlag } from '@/lib/feature-flags-store';
import { pdfDoMeuPlano, useMeuDesenvolvimento } from '@/lib/feedback/feedback-store';
import { FB } from '@/lib/feedback/textos';

export function MeuDesenvolvimentoCard() {
  const rh = useMyFeatureFlag('MENU_RH_ENABLED');
  const feedback = useMyFeatureFlag('FEEDBACK_ENABLED');
  const ligado = rh && feedback;
  const { data } = useMeuDesenvolvimento(ligado);
  const toast = useToast();
  if (!ligado || !data) return null;
  return (
    <Card variant="flat" className="mb-4 space-y-4 p-6" data-testid="meu-desenvolvimento">
      <h2 className="text-sm font-semibold text-ink-1 dark:text-ink-dark-1">{FB.card_meu_desenvolvimento}</h2>
      {data.itens.length === 0 ? (
        <p className="text-sm text-ink-2 dark:text-ink-dark-2">{FB.vazio_meu_desenvolvimento}</p>
      ) : (
        data.itens.map((i) => (
          <div key={i.rodadaId} className="space-y-4 border-t border-line pt-4 first:border-t-0 first:pt-0 dark:border-line-dark">
            <p className="text-xs font-semibold uppercase tracking-[0.08em] text-ink-3">{i.rodada}</p>
            <PlanoPublicado plano={i.plano} rotulos={data.rotulos} />
            <Button variant="ghost" size="sm" onClick={() => void pdfDoMeuPlano(i.rodadaId).catch((e) => toast.show(errMsg(e) ?? '', { variant: 'error' }))}>
              {FB.botao_pdf}
            </Button>
          </div>
        ))
      )}
    </Card>
  );
}
